import { render } from "./StandartCheckbox.vue?vue&type=template&id=15478f80&scoped=true"
import script from "./StandartCheckbox.vue?vue&type=script&lang=js"
export * from "./StandartCheckbox.vue?vue&type=script&lang=js"

import "./StandartCheckbox.vue?vue&type=style&index=0&id=15478f80&scoped=true&lang=css"
import "./StandartCheckbox.vue?vue&type=style&index=1&id=15478f80&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15478f80"]])

export default __exports__